/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_NewInputs */

const en_templates_new = /** @type {(inputs: Templates_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New template`)
};

const he_templates_new = /** @type {(inputs: Templates_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תבנית חדשה`)
};

/**
* | output |
* | --- |
* | "New template" |
*
* @param {Templates_NewInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_new = /** @type {((inputs?: Templates_NewInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_NewInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_new(inputs)
	return he_templates_new(inputs)
});